module.exports = __webpack_public_path__ + "static/img/guanzhu-bg.44fff34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guanzhu-bg.png
// module id = JRoW
// module chunks = 1